import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";

const NavItem = ({ label, to, isActive, onClick, children }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleToggleDropdown = (e) => {
    if (children) {
      setIsDropdownOpen(!isDropdownOpen);
    } else if (onClick) {
      onClick();
    }
  };

  const handleClickOutside = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setIsDropdownOpen(false);
    }
  };

  React.useEffect(() => {
    if (isDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDropdownOpen]);

  return (
    <div className="relative dropdown-container font-poppins navbar-container mt-2">
      <Link
        to={to}
        onClick={handleToggleDropdown}
        className={`relative block text-gray-500 group px-1 py-2 rounded font-poppins text-xm transition-colors ${
          isActive ? "text-gray-800 bg-primary md:bg-transparent" : "hover:text-primary"
        }`}
      >
        <span>{label}</span>
        {/* Central Radial Wave Effect */}
        <span className="absolute wave-effect bg-primary rounded-full opacity-0"></span>
      </Link>
      {isDropdownOpen && children && (
        <div
          ref={dropdownRef}
          className="absolute right-1 top-4 mt-10 z-50 bg-white shadow-lg rounded p-5 grid grid-cols-4 gap-16 w-[900px] md:w-[50px] lg:w-[750px] xl:w-[950px]"
        >
          {React.Children.map(children, (column, columnIndex) => {
            if (!column || !column.props) return null;
            return (
              <div key={columnIndex} className="text-gray-1000">
                <div className="font-semibold text-xs mb-2">{column.props.columnLabel}</div>
                {React.Children.map(column.props.children, (child, childIndex) => {
                  if (!child || !child.props) return null;
                  const isLastChild = childIndex === React.Children.count(column.props.children) - 1;
                  return (
                    <div
                      key={childIndex}
                      className={`border-b ${isLastChild ? 'border-none' : 'border-gray-200'}`}
                    >
                      {React.cloneElement(child, {
                        className: `block text-xs-12 py-2 px-4 hover:text-blue-900 transition-colors text-gray-1000 ${child.props.className || ""}`,
                      })}
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
      )}
      <style jsx>{`
        .wave-effect {
          width: 0;
          height: 0;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%) scale(0); /* Starts at the center */
          background-color: white; /* Lighter primary color */
          border-radius: 50%;
          opacity: 0;
        }
          .group:hover .wave-effect {
          opacity: 0.3; /* Decrease opacity on hover */
        }
        .group:hover .wave-effect {
          animation: waveExpand 1.2s ease-out forwards; /* Trigger animation on hover */
        }
        @keyframes waveExpand {
          0% {
            width: 0;
            height: 0;
            opacity: 0.5;
            transform: translate(-50%, -50%) scale(0);
          }
          70% {
            width: 200px; /* Expands in all directions */
            height: 200px;
            opacity: 0;
            transform: translate(-50%, -50%) scale(1);
          }
          100% {
            width: 200px;
            height: 200px;
            opacity: 0;
            transform: translate(-50%, -50%) scale(1.2); /* Slight extra scale for effect */
          }
        }
      `}</style>
    </div>
  );
};

export default NavItem;
